import "./applicationProcess.css";

const ApplicationProcess = () => {
  return (
    <div className="application-process-page">
      <div className="application-process-container">
        <h2>Application Process</h2>
        <ol>
          <li>
            Phase one
            <ol>
              <li>
                You will:
                <ol type="i">
                  <li>
                    Download{" "}
                    <a
                      href="./ApplicationPackage_en.pdf"
                      target="applicationforms"
                      style={{ color: "red", textDecoration: "underline" }}
                    >
                      the application package
                    </a>{" "}
                    in PDF format.
                  </li>
                  <li>
                    Fill out and submit the Application forms and Bank
                    Verification form. (email to contact@SeattleVT.org)
                  </li>
                  <li>
                    Have official transcripts sent from all schools you have
                    attended in the last two years.
                  </li>
                  <li>Pay the $100 (non-refundable) application fee.</li>
                  <li>
                    Schedule and participate in a video interview with one of
                    our staffs.
                  </li>
                </ol>
              </li>
              <li>
                We will:{" "}
                <ol type="i">
                  <li>
                    Acknowledge receipt of your completed Application and assign
                    an account number.
                  </li>
                  <li>
                    Acknowledge receipt of your completed Bank Verification,
                    Transcripts, and Fee.
                  </li>
                  <li>Schedule the video interview.</li>
                  <li>
                    Evaluate your application and make a decision within 14 days
                    of receipt of the completed materials.
                  </li>
                  <li>Inform you of our decision about admissions.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            Phase two{" "}
            <ol type="a">
              <li>
                If you are admitted, you will:{" "}
                <ol type="i">
                  <li>
                    Pay tuition (two payment plans available, see Payment Plans)
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            Phase three{" "}
            <ol type="a">
              <li>
                We will:{" "}
                <ol type="i">
                  <li>
                    Send you your I-20 documents, and an visa application
                    checklist and advice for applying for your visa, within 14
                    days.
                  </li>
                </ol>
              </li>
              <li>
                You will:{" "}
                <ol type="i">
                  <li>
                    Assemble all required documents and apply for the visa at
                    the nearest US Embassy.
                  </li>
                  <li>
                    Inform us of the success or failure of your application.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
        <br />
        <br />
        <h2>Acknowledgement, Certification, and Compliance Statement</h2>
        <div className="acknowledgement-statement">
          <p>
            By submitting this application, the applicant and, where
            applicable, the parent(s), legal guardian(s), sponsor(s), or
            authorized representatives, certify that all information,
            statements, academic records, transcripts, test scores, financial
            documentation, identification records, immigration-related materials,
            and all other supporting documents submitted to Seattle Voctech
            School are true, complete, accurate, authentic, and unaltered.
          </p>
          <p>
            The applicant understands that Seattle Voctech School relies upon the
            accuracy and authenticity of submitted materials in making
            admissions, enrollment, academic placement, tuition, and immigration
            sponsorship decisions, including the issuance of documents related to
            F-1 student status (where applicable).
          </p>
          <p>
            Any false, misleading, incomplete, altered, forged, fraudulent, or
            intentionally omitted information or documentation submitted at any
            stage of the inquiry, application, admission, enrollment,
            immigration, or academic process shall constitute grounds for
            immediate action, including but not limited to:
          </p>
          <ul>
            <li>Rejection or denial of the application;</li>
            <li>Revocation of admission or enrollment;</li>
            <li>Cancellation or termination of student status;</li>
            <li>
              Immediate withdrawal, cancellation, or reporting of immigration
              sponsorship documentation, including Form I-20 and related records
              in SEVIS, where applicable;
            </li>
            <li>
              Reporting the matter to relevant educational institutions,
              credential evaluators, examination authorities, government agencies,
              immigration authorities, or law enforcement, as required or
              permitted by applicable law;
            </li>
            <li>
              Withholding transcripts, records, certificates, diplomas,
              recommendations, or other institutional documents where legally
              permitted;
            </li>
            <li>
              Recovery of administrative costs, legal fees, compliance expenses,
              investigative costs, chargebacks, losses, or other damages incurred
              by the school as a result of fraudulent or materially misleading
              submissions, to the extent permitted by law.
            </li>
          </ul>
          <p>
            The applicant further authorizes Seattle Voctech School to
            independently verify submitted information with prior schools,
            testing organizations, financial institutions, sponsors, employers,
            government authorities, or other relevant third parties.
          </p>
          <p>
            The applicant acknowledges that any tuition deposits, application
            fees, document processing fees, and other payments made may be
            non-refundable in cases involving fraud, misrepresentation, or
            materially inaccurate submissions, subject to applicable law and
            school policy.
          </p>
          <p>
            By submitting this application, the applicant confirms that they
            have read, understood, and agreed to this certification and
            acknowledge that providing false information may result in serious
            academic, financial, immigration, and legal consequences.
          </p>
        </div>
        <br />
        <br />
        <h2 id="apply">Submit ALL forms (in pdf format) to:</h2>
        <div
          className="paragraph"
          style={{ textAlign: "left", display: "block" }}
        >
          <span>
            contact@SeattleVT.org
            <br />
            Subject: International Admissions{" "}
          </span>
        </div>
        <h2 id="apply">Questions?</h2>
        <div
          className="paragraph"
          style={{
            textAlign: "left",
            display: "block",
            marginBottom: "50px",
          }}
        >
          <span>
            If you need assistance with any part of the application process,
            please contact the Admissions Coordinator:{" "}
            <a href="mailto:contact@Seattlevt.org">contact@SeattleVT.org</a>{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcess;
